// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__dwrZO","gfeWrapper":"CalendarEvent_gfeWrapper__2rA15"};